<template>
  <transition name="flipInX">
    <div class="settings-container">
      <div id="logout" @click="logout">
        <font-awesome-icon icon="sign-out-alt" />
        Log out
      </div>
    </div>
  </transition>
</template>

<script>
import {auth} from '../../firebase/firebaseConfig'
import Mixin from '../mixins/HelperFunctions.js'
export default {
  mixins: [Mixin],
  name: 'Settings',
  props: {},
  created() {},
  data: function (){
    return {}
  },
  computed: {},
  methods: {
    logout: function () {
      auth.signOut().then(() => {
        this.$store.commit('logOut')
        this.$router.go('/')
      }).catch(function(error){
        console.log('badness', error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.settings-container {
  z-index: 500;
  background: #772e25;
  position: fixed;
  padding: 10px 20px 10px 10px;
  margin: 0;
  top: 5px;
  left: 0;
  box-shadow: 0 8px 6px -6px black;
  border: 1px solid #5B1C16;
  border-left: none;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  -webkit-transition: background 0.5s;
  &:hover {
    cursor: pointer;
    background: #5B1C16;
    color: #FFF;
    -webkit-transition: background 0.5s;
  }
}

</style>
